// Renders a service thumbnail. Video sources (mp4/webm) autoplay like the old
// animated GIFs did; everything else renders as a plain image. Keeps the same
// element position so the `> :is(img, video)` CSS rules apply to both.
const isVideo = (src) => /\.(mp4|webm)$/i.test(src || "");

const ServiceMedia = ({ src, alt, onClick }) =>
  isVideo(src) ? (
    <video
      src={src}
      onClick={onClick}
      aria-label={alt}
      autoPlay
      loop
      muted
      playsInline
    />
  ) : (
    <img src={src} alt={alt} onClick={onClick} />
  );

export default ServiceMedia;
